Product = new Object();
Product.init = function () {
  Product.calculateDeliveryDate(2);
};

Product.calculateDeliveryDate = function (x) {
  var currentDate = new Date();
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(startDate, numDays) {
    var newDate = new Date(startDate);
    var businessDays = 0;
    while (businessDays < numDays) {
      newDate.setDate(newDate.getDate() + 1);
      // Check if the current day is a business day (Monday to Friday)
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        businessDays++;
      }
    }
    return newDate;
  }

  // Calculate the first delivery date (skipping weekends)
  var firstDeliveryDate = addBusinessDays(currentDate, x);
  // Get day, date, and month for the first delivery date
  var firstDayName = days[firstDeliveryDate.getDay()];
  var firstDay = firstDeliveryDate.getDate();
  var firstMonth = months[firstDeliveryDate.getMonth()];
  var firstFormattedDate = firstDayName + ', ' + firstDay + ' ' + firstMonth;
  $('.product-main__status span.delivery_date').text(firstFormattedDate);
}

function add_variant_to_cart(v_id, quantity, s_id) {
  jQuery.getJSON('/cart.js', function (cart) {
    const data = {
      id: v_id,
      quantity: quantity,
      selling_plan: s_id
    };
    if (parseFloat(s_id) <= 0) {
      data.remove(selling_plan);
      console.log(data);
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: data,
      success: function () {
        console.log('added', data);
         window.location.replace('/cart');
      },
    }); 
  });
}



$(document).ready(function () {
  Product.init();
  
  const sub_class = {
    true: 'product-main__product-wrapper--sub',
    false: 'product-main__product-wrapper--one'
  }
  
  // // Separate variables for subscription and one-time purchase selections
  let selectedFreq = 1636368418; // unused
  let subSelectedQuantity = 1;
  let oneTimeSelectedQuantity = 1;
  let selectedSub = true;
  let selectedVariantId = undefined;
  

  // Toggle active class between subscription and one-time purchase sections
  $('.product-main__product-wrapper').click(function () {
    selectedSub = $(this).hasClass(sub_class.true);
    $('.product-main__product-wrapper').removeClass('active');
    $(this).addClass('active');
    // updateImages();
    updatePrice(sub_class[selectedSub]);
  });

  function handleQuantitySelection(wrapperClass) {
    $(`.${wrapperClass} .variant__quantity-option`).click(function () {
      // updateImages();
      if (wrapperClass === sub_class.true) {
        subSelectedQuantity = $(this).data('quantity');
      } else {
        oneTimeSelectedQuantity = $(this).data('quantity');
      }
      $(`.${wrapperClass} .variant__quantity-option`).removeClass('selected');
      $(this).addClass('selected');
      updatePrice(wrapperClass);
    });
  }
   
  function handleFrequencySelection() {
    $(`.${sub_class.true} .variant__frequency-option`).click(function () {
      // updateImages();
      if (sub_class.true === sub_class.true) {
        selectedFreq = $(this).data('plan-id');
      }
      $(`.${sub_class.true} .variant__frequency-option`).removeClass('selected');
      $(this).addClass('selected');
      updatePrice(sub_class.true);
    });
  }

  function handleVariantSelection() {
      const variant__option = $('.variant__option.selected');
      if(!variant__option) return;
  
      $(`.variant__option`).click(function () {
      $(`.variant__option.selected`).removeClass('selected');
      $(this).addClass('selected');
      updatePrice(sub_class.true);
    });
  }

  function updatePrice(wrapperClass) {
    const quantity = wrapperClass === sub_class.true ? Number(subSelectedQuantity) : Number(oneTimeSelectedQuantity);
    if(sub_class.true === wrapperClass){
            selectedVariantId = $(`.variant__option.selected`).data('variantid');
    }
    if(quantity){
      const atcButton = $('#add-to-cart-button');
      const tempWorkaround = $('.variant-options .selected').data('name') // '2 oz' // this will actually be quantity (1 jar, 2 jars, 3 jars) - now its just 1oz, 2oz

      const selectedVariant = $(`#variants-data .variant-data[data-quantity="${tempWorkaround}"]`);
      const isSubscription = wrapperClass === sub_class.true;
      console.log(selectedFreq);
      const priceData = isSubscription
        ? $(`#variants-data .variant-data[data-quantity="${tempWorkaround}"] .subscription-data[data-plan-id="${selectedFreq}"]`)
        : selectedVariant;     

      console.log("priceData",priceData);
      
      if (priceData.length) {
        if (!selectedVariant.data('available')) {
          atcButton.text('SOLD OUT').prop('disabled', true);
          return;
        }
        const variantId = priceData.data('id');
        
        const price = (priceData.data('price') * quantity / 100).toFixed(2);
        const compare = selectedVariant.data('compare-price') || priceData.data('compare-price');
        const comparePrice = (compare * quantity / 100).toFixed(2);
        const saveAmount = comparePrice - price;
        const savePercentage = Math.round((comparePrice - price) * 100 / comparePrice);

         atcButton.prop('disabled', false)
          .data('id', variantId)
          .data('plan-id', isSubscription ? priceData.data('plan-id') : undefined)
          .text(`ADD TO BAG - $${price}`);

        const priceClass = isSubscription ? '.product-main__price-wrapper.sub' : '.product-main__price-wrapper.one';
        $(`${priceClass} .product-main__price .sellprice`).text(`$${price}`);

        if(selectedSub){
          const pricePerJar = (price / quantity).toFixed(2);
          $(`${priceClass} .product-main__price > span`).text(`$${comparePrice}`);
          $(`${priceClass} .product-main__price-discount span`).text(`You're Saving $${saveAmount}`);
        }else{
          $(`${priceClass} .product-main__price .compareprice`).text(`$${comparePrice}`);
        }
      } else {
        atcButton.data('id', '').data('plan-id', '').text('Select a valid option');
      }
    }
  }
  
   function upDateOntimePrice(){
    
   }

  // function updateImages() {
  //   const quantity = selectedSub ? subSelectedQuantity : oneTimeSelectedQuantity;
  //   $('.product-main__images-dynamic .variant-image').hide();
  //   $(`.product-main__images-dynamic .variant-image[data-quantity="${quantity}"]`).show();
  // }

  // // Set up flavor and quantity selection for both subscription and one-time purchase options
  handleQuantitySelection(sub_class.true);
  handleQuantitySelection(sub_class.false);
  handleFrequencySelection();
  handleVariantSelection();
  $(`.${sub_class.true} .variant__frequency-option`)[0].click();
  updatePrice(sub_class.false); // false a.k.a. one-time variant first, so to set the sub-variant active on atc
  updatePrice(sub_class.true);
  // updateImages();

  // Handle Add to Cart button click
  $('#add-to-cart-button').click(function (e) {
    e.preventDefault();
    const variantId = $(this).data('id');
    const planId = $(this).data('plan-id');
    const quantity = selectedSub ? subSelectedQuantity : oneTimeSelectedQuantity;
    console.log("Selected Sub: ", selectedSub, "\nVariant ID: ", variantId, "\nPlan ID: ", planId);

    if (variantId) {
      add_variant_to_cart(variantId, quantity, selectedSub ? planId : null);
    } else {
      alert("Please select a valid quantity.");
    }
  });
});



